<kendo-card class="kpa-announcements-card">
	<kendo-card-header>
		<div *ngIf="!isDashboard">All Announcements</div>
		<div *ngIf="isDashboard">New Announcements</div>
	</kendo-card-header>
	<kendo-card-body>
		<kendo-stacklayout
			[gap]="15"
			style="padding: 20px"
			[orientation]="'vertical'">
			<ng-container *ngIf="pagedAnnouncements && pagedAnnouncements.length; else noAnnouncements">
				<kendo-card
					[ngClass]="isDashboard ? 'kendo-child-card-dashboard' : 'kendo-child-card'"
					*ngFor="let item of pagedAnnouncements"
					width="auto">
					<kendo-card-body>
						<div class="kendo-child-card-content">
							<div class="kendo-child-card-content-container">
								<div class="announcement-icon-wrapper">
									<kendo-svg-icon [icon]="announcementIcon"></kendo-svg-icon>
								</div>
								<div class="announcement-content-wrapper">
									<div class="announcement-content-group">
										<div class="announcement-content-header-wrapper">
											<b class="announcement-content-header">{{ item.name }} </b>
										</div>
										<div class="announcement-content-date">{{ item.dateAdded | date: 'MM/dd/yyyy' }}</div>
										<div class="announcement-content-group">
											<div class="announcement-content-body">
												<span [innerHTML]="item.messageText"></span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</kendo-card-body>
				</kendo-card>
				<div
					*ngIf="isDashboard"
					class="view-all-wrapper">
					<button
						kendoButton
						(click)="viewAnnouncements()"
						fillMode="flat">
						View All Announcements <kendo-svg-icon [icon]="chevronRightIcon"></kendo-svg-icon>
					</button>
				</div>
			</ng-container>
			<ng-template #noAnnouncements>
				<p
					*ngIf="isDashboard"
					class="kpa-no-announcements">
					<kendo-svg-icon [icon]="noannouncementIcon"></kendo-svg-icon> {{ noAnnouncementsDashboardMessage
					}}<span (click)="viewAnnouncements()">Announcements.</span>
				</p>
				<p
					*ngIf="!isDashboard"
					class="kpa-no-announcements">
					<kendo-svg-icon [icon]="noannouncementIcon"></kendo-svg-icon> {{ noAnnouncementsMessage }}
				</p>
			</ng-template>
		</kendo-stacklayout>
	</kendo-card-body>
	<div
		*ngIf="!isDashboard"
		style="padding: 0px 20px 15px 20px">
		<kendo-datapager
			style="width: 100%"
			class="kpa-announcements-pager"
			[pageSize]="pageSize"
			[skip]="skip"
			[total]="total"
			[pageSizeValues]="true"
			[info]="true"
			[previousNext]="true"
			(pageChange)="onPageChange($event)">
		</kendo-datapager>
	</div>
</kendo-card>
